<template>
	<div class="m-foot u-pl32 u-pr32 u-pt40 u-pb40">
		<p v-if="explain">说明：表里的所有指数数据，取创立以来历史数据，有些平台上位置高度不一样，大概率是因为时间维度不同，PE、PB百分位越低，代表该指数目前所处历史位置越低。数据来源：同花顺iFinD数据中心。</p>
        <dl>
            <dt>免责说明：</dt>
            <dd>1.本专题内容均为基于公开数据计算结果，请谨慎参考。</dd>
            <dd>2.专题页任何信息或者意见并不构成投资建议。投资者不能直接根据此做出买入或者卖出判断。</dd>
            <dd>3.基金过往业绩不预示其未来表现，市场有风险，投资需谨慎。</dd>
            <dd>4.基金销售服务由浙江同花顺基金销售有限公司提供。</dd>
        </dl>
    </div>
</template>

<script>
    export default {
        name: "foot",
        props: {
            explain: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
			}
        }
    }
</script>

<style lang="less">
.m-foot {
    p {
        margin-bottom: 24px;
    }   
    p, dt, dd {
        line-height: 36px;
        font-weight: 400;
        font-size: 24px;
        text-align: justify;
        color: #B3B3B3;
    }
}
</style>
